var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leads"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0334 22.0939C15.2237 22.0939 14.5664 22.7511 14.5664 23.5609C14.5664 24.3706 15.2237 25.0279 16.0334 25.0279C16.8432 25.0279 17.5004 24.3706 17.5004 23.5609C17.5004 22.7511 16.8432 22.0939 16.0334 22.0939ZM16.0334 22.6393C16.542 22.6393 16.955 23.0523 16.955 23.5609C16.955 24.0695 16.542 24.4825 16.0334 24.4825C15.5248 24.4825 15.1118 24.0695 15.1118 23.5609C15.1118 23.0523 15.5248 22.6393 16.0334 22.6393Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5393 12.9403C25.7295 12.9403 25.0723 13.5976 25.0723 14.4073C25.0723 15.2171 25.7295 15.8743 26.5393 15.8743C27.349 15.8743 28.0063 15.2171 28.0063 14.4073C28.0063 13.5976 27.349 12.9403 26.5393 12.9403ZM26.5393 13.4857C27.0478 13.4857 27.4609 13.8987 27.4609 14.4073C27.4609 14.9159 27.0478 15.3289 26.5393 15.3289C26.0307 15.3289 25.6177 14.9159 25.6177 14.4073C25.6177 13.8987 26.0307 13.4857 26.5393 13.4857Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9533 8.93628C13.1436 8.93628 12.4863 9.59355 12.4863 10.4033C12.4863 11.213 13.1436 11.8703 13.9533 11.8703C14.7631 11.8703 15.4203 11.213 15.4203 10.4033C15.4203 9.59355 14.7631 8.93628 13.9533 8.93628ZM13.9533 9.48168C14.4619 9.48168 14.8749 9.89471 14.8749 10.4033C14.8749 10.9119 14.4619 11.3249 13.9533 11.3249C13.4448 11.3249 13.0317 10.9119 13.0317 10.4033C13.0317 9.89471 13.4448 9.48168 13.9533 9.48168Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4897 26.7341C18.4897 26.372 18.3461 26.0247 18.0905 25.7692C17.8349 25.5136 17.4876 25.3711 17.1261 25.3711C16.4588 25.3711 15.607 25.3711 14.9397 25.3711C14.5782 25.3711 14.2309 25.5136 13.9753 25.7692C13.7198 26.0247 13.5762 26.372 13.5762 26.7341V28.9194C13.5762 29.0701 13.6979 29.1914 13.8487 29.1914H18.2172C18.3679 29.1914 18.4897 29.0701 18.4897 28.9194V26.7341ZM17.9447 26.7341V28.6475H14.1211V26.7341C14.1211 26.5162 14.2074 26.3081 14.3609 26.1558C14.5143 26.0018 14.7224 25.915 14.9397 25.915H17.1261C17.3435 25.915 17.5515 26.0018 17.705 26.1558C17.8584 26.3081 17.9447 26.5162 17.9447 26.7341Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9955 17.5808C28.9955 17.2187 28.8519 16.8714 28.5964 16.6158C28.3408 16.3603 27.9935 16.2178 27.632 16.2178C26.9647 16.2178 26.1128 16.2178 25.4456 16.2178C25.0841 16.2178 24.7368 16.3603 24.4812 16.6158C24.2256 16.8714 24.082 17.2187 24.082 17.5808V19.7661C24.082 19.9168 24.2038 20.038 24.3545 20.038H28.723C28.8738 20.038 28.9955 19.9168 28.9955 19.7661V17.5808ZM28.4506 17.5808V19.4942H24.627V17.5808C24.627 17.3629 24.7133 17.1548 24.8667 17.0025C25.0202 16.8485 25.2282 16.7617 25.4456 16.7617H27.632C27.8493 16.7617 28.0574 16.8485 28.2108 17.0025C28.3643 17.1548 28.4506 17.3629 28.4506 17.5808Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4096 13.5768C16.4096 13.2148 16.266 12.8675 16.0104 12.6119C15.7549 12.3564 15.4076 12.2139 15.0461 12.2139C14.3788 12.2139 13.5269 12.2139 12.8596 12.2139C12.4981 12.2139 12.1508 12.3564 11.8953 12.6119C11.6397 12.8675 11.4961 13.2148 11.4961 13.5768V15.7622C11.4961 15.9129 11.6179 16.0341 11.7686 16.0341H16.1371C16.2878 16.0341 16.4096 15.9129 16.4096 15.7622V13.5768ZM15.8646 13.5768V15.4903H12.0411V13.5768C12.0411 13.359 12.1273 13.1509 12.2808 12.9986C12.4342 12.8446 12.6423 12.7577 12.8596 12.7577H15.0461C15.2634 12.7577 15.4714 12.8446 15.6249 12.9986C15.7783 13.1509 15.8646 13.359 15.8646 13.5768Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9869 22.5209C20.9869 21.7677 20.3761 21.1573 19.623 21.1573C17.8215 21.1573 14.2455 21.1573 12.444 21.1573C11.6909 21.1573 11.0801 21.7677 11.0801 22.5209C11.0801 24.1364 11.0801 27.1484 11.0801 28.7639C11.0801 29.5171 11.6909 30.1274 12.444 30.1274H14.4931L15.8154 31.8908C15.8669 31.9595 15.9479 31.9999 16.0335 31.9999C16.1192 31.9999 16.2001 31.9595 16.2516 31.8908L17.5739 30.1274H19.623C20.3761 30.1274 20.9869 29.5171 20.9869 28.7639V22.5209ZM20.4412 22.5209V28.7639C20.4412 29.2159 20.0752 29.5823 19.623 29.5823H17.4377C17.352 29.5823 17.271 29.6228 17.2196 29.6914L16.0335 31.2724L14.8475 29.6914C14.796 29.6228 14.715 29.5823 14.6293 29.5823H12.444C11.9919 29.5823 11.6258 29.2159 11.6258 28.7639V22.5209C11.6258 22.0689 11.9919 21.7024 12.444 21.7024C14.2455 21.7024 17.8215 21.7024 19.623 21.7024C20.0752 21.7024 20.4412 22.0689 20.4412 22.5209Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4928 13.3683C31.4928 12.6152 30.882 12.0048 30.1289 12.0048C28.3273 12.0048 24.7514 12.0048 22.9499 12.0048C22.1968 12.0048 21.5859 12.6152 21.5859 13.3683C21.5859 14.9838 21.5859 17.9958 21.5859 19.6113C21.5859 20.3645 22.1968 20.9749 22.9499 20.9749H24.999L26.3213 22.7382C26.3727 22.8069 26.4537 22.8473 26.5394 22.8473C26.625 22.8473 26.706 22.8069 26.7575 22.7382L28.0797 20.9749H30.1289C30.882 20.9749 31.4928 20.3645 31.4928 19.6113V13.3683ZM30.947 13.3683V19.6113C30.947 20.0633 30.581 20.4298 30.1289 20.4298H27.9435C27.8579 20.4298 27.7769 20.4702 27.7254 20.5389L26.5394 22.1198L25.3533 20.5389C25.3018 20.4702 25.2209 20.4298 25.1352 20.4298H22.9499C22.4977 20.4298 22.1317 20.0633 22.1317 19.6113V13.3683C22.1317 12.9163 22.4977 12.5499 22.9499 12.5499C24.7514 12.5499 28.3273 12.5499 30.1289 12.5499C30.581 12.5499 30.947 12.9163 30.947 13.3683Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9069 9.36359C18.9069 8.61039 18.2961 8 17.5429 8C15.7414 8 12.1655 8 10.3639 8C9.61081 8 9 8.61039 9 9.36359C9 10.9791 9 13.991 9 15.6065C9 16.3597 9.61081 16.9701 10.3639 16.9701H12.4131L13.7353 18.7334C13.7868 18.8021 13.8678 18.8426 13.9534 18.8426C14.0391 18.8426 14.1201 18.8021 14.1715 18.7334L15.4938 16.9701H17.5429C18.2961 16.9701 18.9069 16.3597 18.9069 15.6065V9.36359ZM18.3611 9.36359V15.6065C18.3611 16.0585 17.9951 16.425 17.5429 16.425H15.3576C15.2719 16.425 15.191 16.4654 15.1395 16.5341L13.9534 18.115L12.7674 16.5341C12.7159 16.4654 12.6349 16.425 12.5493 16.425H10.3639C9.91177 16.425 9.54576 16.0585 9.54576 15.6065V9.36359C9.54576 8.91158 9.91177 8.5451 10.3639 8.5451C12.1655 8.5451 15.7414 8.5451 17.5429 8.5451C17.9951 8.5451 18.3611 8.91158 18.3611 9.36359Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/Card1.0a152a3e2883f04511fb4ac173ac6469.svg";
export { ForwardRef as ReactComponent };